// -------- GENERAL --------
export const RESET_GENERAL_STATE = 'resetGeneralState';
export const SET_AFTER_LOGIN = 'setAfterLogin';
export const SET_CURRENT_TAB = 'setCurrentTab';
export const SET_IS_CALLED_CURRENT_USER = 'setIsCalledCurrentUser';
export const SET_IS_LOADING = 'setIsLoading';
export const SET_IS_NOTICE_LOADING = 'setIsNoticeLoading';
export const SET_IS_WAITING = 'setIsWaiting';
export const SET_IS_WAITING_ORDER = 'setIsWaitingOrder';
export const SET_MESSAGE = 'setMessage';
export const SET_OVERLAY = 'setOverlay';
export const SET_PAGE_LOADING = 'setPageLoading';
export const SET_REMOVE_LOADING = 'setRemoveLoading';
export const SET_SHOW = 'setShow';
export const SET_SHOW_COMPONENT = 'setShowComponent';
export const SET_SHOW_EDIT_POPUP = 'setShowEditPopup';
export const SET_SHOW_LOGIN_AS = 'setShowLoginAs';
export const SET_SHOW_POPUP = 'setShowPopup';
export const SET_SHOW_POPUP_DETAIL = 'setShowPopupDetail';
export const SET_SHOW_RELATED_OBJECT_WARNING_POPUP = 'setShowRelatedObjectWarningPopup';
export const SET_SHOW_REMOVE_POPUP = 'setShowRemovePopup';
export const SET_SHOW_UNSAVED_CHANGE_POPUP = 'setShowUnsavedChangePopup';
export const SET_SIDEBAR_SHOW = 'setSidebarShow';
export const TOGGLE_THEME = 'toggleTheme';
